<template>
  <div>
    <el-row style="margin-top:20px">
      <el-col :xl="4" :md="6">
        <span>
          盘库日期：{{titleList[0].ENTRY_DATE}}
        </span>
      </el-col>
      <el-col :xl="8" :md="10">
        <span>
          盘库单编号：{{titleList[0].PK_CODE}}
        </span>
      </el-col>
      <el-col :xl="8" :md="6" v-if="titleList[0].COMMENT">
        <span>
          驳回理由：{{titleList[0].COMMENT}}
        </span>
      </el-col>
    </el-row>
    <el-row style="margin:10px auto">
      <el-col :span="24">
        <el-table :data="tableData" stripe border show-summary style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="BATCH" label="批次" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="45"></el-table-column>
          <el-table-column prop="BEFORE_COUNT" label="盘前库存" min-width="45"></el-table-column>
          <el-table-column prop="AFTER_COUNT" label="盘后库存" min-width="45"></el-table-column>
          <el-table-column prop="BEFORE_WORTH" label="盘前价值" min-width="45"></el-table-column>
          <el-table-column prop="AFTER_WORTH" label="盘后价值" min-width="45"></el-table-column>
          <el-table-column prop="CURRENT_OFFSET_WORTH" label="盘盈/盘亏" min-width="45">
            <template slot-scope="scope">
              <span :style="$_setFontColor(scope.row.CURRENT_OFFSET_WORTH)">
                {{scope.row.CURRENT_OFFSET_WORTH}}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="CURRENT_OFFSET_WORTH_BEFORE_TAX" label="盘盈/盘亏（不含税）" min-width="45">
            <template slot-scope="scope">
              <span :style="$_setFontColor(scope.row.CURRENT_OFFSET_WORTH_BEFORE_TAX)">
                {{scope.row.CURRENT_OFFSET_WORTH_BEFORE_TAX}}
              </span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="SINGLE_RATE" label="盘盈/盘亏比例（%）" min-width="45">
            <template slot-scope="scope">
              <span :style="$_setFontColor(scope.row.SINGLE_RATE)">
                {{scope.row.SINGLE_RATE}}
              </span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="COMMENT" label="盘库说明" min-width="45"></el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row style="height:100px" v-if="show">
      <el-col :xl="{span: 3, offset: 21}" :lg="{span: 3, offset: 20}" :md="{span: 6, offset: 18}">
        <el-button size="medium" @click="confirmSuccess">通过</el-button>
        <el-button size="medium" @click="refuse">拒绝</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        {{comments}}
      </el-col>
    </el-row>
    <el-dialog title="拒绝原因" center :visible.sync="dialog" width="500px">
      <el-input v-model="refuseComment"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialog = false">取 消</el-button>
        <el-button size="small" @click="confirmRefuse">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';


export default {
  data() {
    return {
      comments: '',
      isDisabled: false,
      setButtonText: '',
      loading: false,
      tableData: [],
      titleList: [{
        ENTRY_DATE: '',
        PK_CODE: '',
      }],
      dialog: false,
      refuseComment: '',
      show: Number(this.$route.params.status) == 101,
    };
  },
  created() {
    this.queryDetail();
  },
  computed: {
    // isDisabled() {
    //   return this.titleList[0].STATUS === 3;
    // },
    // setButtonText() {
    //   return this.titleList[0].STATUS === 3 ? '已审批' : '通过';
    // },
  },
  methods: {
    // 设置盘盈盘亏颜色显示
    $_setFontColor(number) {
      return this.setFontColor(Number(number));
    },
    queryDetail() {
      const data = {
        SERVICE_ID: '10030',
        OTYPE: 3,
        PK_CODE: this.$route.params.pkc,
        PK_ID: Number(this.$route.params.id),
      };
      http.post(data).then((result) => {
        if (result[0]) {
          this.tableData = result[0].PK_DETAIL;
          this.titleList = result[0].OP_ROLE;
          this.comments = result[1].PK_RECORD;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    confirmSuccess() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10030',
            OTYPE: 17,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PK_ID: Number(this.$route.params.id),
          };
          http.post(data).then((res) => {
            this.$message.show({ text: '审批成功', type: 'success' });
            this.$router.go(-1);
            document.body.style.cursor = 'default';
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    refuse() {
      this.dialog = true;
    },
    confirmRefuse() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10030',
            OTYPE: 16,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PK_ID: Number(this.$route.params.id),
          };
          if (this.refuseComment != '') {
            data.COMMENT = this.refuseComment;
          }
          http.post(data).then((res) => {
            this.$message.show({ text: '审批成功', type: 'success' });
            this.$router.go(-1);
            document.body.style.cursor = 'default';
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    setPkWorth(row) {
      return Math.round(row.PK_COUNT * row.PRODUCT_PRICE * 100) / 100;
    },
    // 设置盘盈盘亏颜色显示
    setFontColor(number) {
      if (number > 0) {
        return {
          color: '#67C23A',
        }; // green
      } if (number === 0) {
        return {
          color: '#606266',
        }; // normal
      }
      return {
        color: '#F56C6C',
      }; // red
    },

  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/audit/stockCheckAuditDetail.vue